import { HTTP_TYPES } from '@/lib/enums'
import api from '@/api/api'
import { get } from '@vueuse/core'

const response = {
  async postProfile(payload: any): Promise<any> {
    // place_id: string
    // reference: string
    // source: string
    // fetch_responses: boolean
    // subscribe: boolean

    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile`,
      payload
    )
  },
  async getProfileById(profileId: string): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile/${profileId}/`
    )
  },
  async removeSubscriptionFromProfile(profileId: string): Promise<any> {
    return await api(
      HTTP_TYPES.DELETE,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile/${profileId}`
    )
  },
  async postAddSubscriptionToProfile(profileId: string): Promise<any> {
    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile/${profileId}/subscribe`
    )
  },
  async postSubscribeAndFetch(profileId: string, payload: any): Promise<any> {
    // client_id: string (required when subscribed is true)
    // subscribed: boolean
    // fetch_responses: boolean

    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile/${profileId}/subscribe-and-fetch`,
      payload
    )
  },
  async getProfileByReference(reference: string): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile/reference/${reference}`
    )
  },
  // Bulk create of Google profiles from a place_id CSV. Streams Server-Sent Events,
  // passed to `onChunk` raw: the page shows them as sent, so a frame split across
  // chunks is harmless. Aborting `signal` stops the run server-side.
  async createProfilesFromCsv(
    formData: FormData,
    onChunk: (chunk: string) => void,
    signal?: AbortSignal
  ): Promise<void> {
    await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/create-from-csv`,
      formData,
      undefined,
      'application/json',
      'v1',
      {},
      onChunk,
      signal
    )
  },
  async postUpdateProfileStatus(profileUuid: string, payload: any): Promise<any> {
    // status: string

    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/profile/status/${profileUuid}`,
      payload
    )
  }
}

export default response